import { StyleSheet } from 'react-native';

const baseStyles = {
    itemContainer: {
        height: 2
    }
};

export default StyleSheet.create(baseStyles);
